import { render, staticRenderFns } from "./PolicySign.vue?vue&type=template&id=82652f56"
import script from "./PolicySign.vue?vue&type=script&lang=ts"
export * from "./PolicySign.vue?vue&type=script&lang=ts"
import style0 from "./PolicySign.vue?vue&type=style&index=0&id=82652f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports